export default [
  {
    title: 'Oferta',
    route: 'oferta-academica',
    icon: 'GridIcon',
  },
]
